<template>
  <div class="gray-back" style="padding: 0.2rem 0 1rem 0">
    <van-form @submit="onSubmit" @failed="onFailed">
      <van-divider>备注信息</van-divider>

      <van-cell-group>

          <van-field
                  v-model="formData.pay_off_date"
                  :rules="[{ required: true, message: '请输入汇款时间' }]"
                  label="汇款时间"
                  :border="false"
                  input-align="right"
                  error-message-align="right"
                  clearable
                  placeholder="请输入汇款时间"
          />
          <van-field
                  v-model="formData.pay_off_id"
                  :rules="[{ required: true, message: '请输入汇款订单号' }]"
                  label="汇款订单号"
                  :border="false"
                  input-align="right"
                  error-message-align="right"
                  clearable
                  placeholder="请输入汇款订单号"
          />


        <van-cell
          title="线下支付凭证"
          :value="formData.order_pics.length + '/2'"
        >
          <!--<template slot="icon" >-->
          <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
          <!--</template>-->
        </van-cell>

        <div class="row">
          <PicUploader
            :fileList="formData.order_pics"
            :limit="2"
            :name="'order_pics'"
          ></PicUploader>
        </div>
        <div class="operate-desc-left">上传支付凭证</div>
      </van-cell-group>

      <div class="savebtn">
        <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal"
          round
          :disabled="saveLoading"
          :loading="saveLoading"
          loading-text="提交中..."
          @click="submit"
          >确定提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.fapiao-tip-wrap {
  background: #f3f3f3;
  margin: 0.2rem;
  border-radius: 8px;
  line-height: 36px;
  padding: 0.2rem;
  font-size: 14px;
  color: #666;
}
.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}
.between {
  justify-content: space-between;
}
</style>
<script>
import Vue from "vue";
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import FileUploader from "@/components/picker/FileUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";
import CaipanPicker from "@/components/picker/CaipanPicker.vue";
import FamliyPicker from "@/components/picker/FamliyPicker.vue";

import PayDialog from "@/components/PayDialog.vue";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(ActionSheet)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "SaiApplyFapiao",
  components: {
    [Field.name]: Field,
    PicUploader,
    PayDialog,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      payDialogShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: "",
      submitType: "",
      subjectName: "",
      orderIds: [],
      subjectArray: [],
      subjectOptions: [],
      row: {
        order: {},
      },
      formData: {
        id:0,
        pay_off_id:'',
        pay_off_date:'',
        order_pics:[],
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id;
    document.title = "备注填写";
    if (that.row.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {},
  },
  destroyed() {},
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },
    onSubmit(values) {
      console.log("onSubmit-values", values);
      console.log("submitType", this.submitType);

      let that = this;
      console.log(that.formData);
      that.formValidate = true;
      for (let field in that.formData) {
        // console.log(field);
      }

      if (!that.formData.order_pics.length) {
        Toast("请上传支付凭证");
        return;
      }

      that.saveLoading = true;

      that.$api.post(
        "/api/huiyi/beizhusave",
        {
          id: that.formData.id,
          order_pics: that.formData.order_pics,
          pay_off_id: that.formData.pay_off_id,
          pay_off_date: that.formData.pay_off_date,
        },
        (res) => {
          that.saveLoading = false;

          Toast.success("保存成功");

          setTimeout(function () {
            // rbLink({
            //     name:'ISaiApplyDetail',
            //     query:{
            //         id: that.row.id
            //     }
            // },'back')

            // 改成跳转到列表页面
            rbLink({
              name: "HuiyiApplyList",
              query: {
                // id: that.row.id
              },
            });
          }, 100);
        },
        (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        }
      );
    },
    save(values) {
      this.submitType = "save";
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    submit(values) {
      this.submitType = "submit";
    },
    fetch() {
      let that = this;
      that.$api.post(
        "/api/huiyi/beizhudetail",
        {
          id: that.row.id,
        },
        (res) => {
          that.formData = res.data;
        },
        (res) => {
          Toast.fail(res.msg);
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// Tpage1.vue?95a9a1b4